import React, { useRef, useState } from "react";
import ContactPipeline from "./ContactPipeline";
import ContactMilestone from "./ContactMilestone";
import { useContacts } from "../../../app/hooks/useContacts";
import AjaxLoader from "../../../app/common/common-components/AjaxLoader";
import ContactFilter from "./ContactFilter";
import { OMSDiaryNoteItem } from "../../../app/common/common-components/OMSDiaryNoteComponents/OMSDiaryNoteItem";
import { useStore } from "../../../app/stores/store";
import { toast } from "react-toastify";
import ContactGrid from "../ContactGrid";
import {
  LEAD_ACTION_TYPE,
  LEAD_DATE_RANGE_FILTER,
  LEAD_TYPE,
  VIEW,
  VIEW_TYPE,
} from "../constants";
import ContactLeadGrid from "../ContactLeadGrid";
import NewMessageDialog from "../SaveContactTabs/MessageTab/NewMessageDialog";
import { RequirementFilterModal } from "../RequirementFilterModal";

const ContactBoard = () => {
  const [isRequirementModalOpen, setRequirementModalOpen] = useState(false);
  const [filters, setFilters] = useState({});

  const {
    contactInfo = {},
    handleChangeLeadActionType = () => {},
    handleChangeLeads = () => {},
    handleChangeLeadType = () => {},
    handleChangeSeachText = () => {},
    handleClickLead = () => {},
    handleClickSendEmail = () => {},
    handleContactViewTypeChange = () => {},
    handleDragEnd = () => {},
    handleLeadDateRangeChange = () => {},
    handleOnClickMenu = () => {},
    handleTagsChange = () => {},
    handleViewTypeChange = () => {},
    handleWhatsappClick = () => {},
    isLoading = true,
    loadDiaryAjaxForContact = () => {},
    milestoneMaxHeight = 0,
    tagColorFormatter = () => {},
    updateMilestone = () => {},
    view = VIEW.DEFAULT,
    handleSaveRequirement,
    requirementInfo,
    resetRequirementInfo,
  } = useContacts({ setFilters });

  const contactType = contactInfo.selectedContactView;
  const viewType = contactInfo.selectedViewType;
  const noteItemRef = useRef();
  const [currentContactId, setCurrentContactId] = useState("");
  const [newMessageDialogOpen, setNewMessageDialogOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [initialMessage, setInitialMessage] = useState(null);
  const {
    userStore: { userSession },
  } = useStore();
  const userId = userSession?.userId;

  const {
    officeTags = [],
    sourceTypesTag = [],
    usersDD = [],
    userTags = [],
    actions = [],
    cPipelines = [],
    diaryActionTags = [],
    mLeadActionType = LEAD_ACTION_TYPE.NEW,
    mLeadDateRange = LEAD_DATE_RANGE_FILTER.LAST_30_DAYS,
    mLeads = 0,
    mLeadType = LEAD_TYPE.ALL,
    pipelines = [],
    searchTerm = "",
    selectedPipelineId = 0,
    stages = [],
  } = contactInfo;

  const handleSaveFilters = (filterPayload) => {
    setRequirementModalOpen(false);
    console.log("handleSaveFilters:", filterPayload);
    if (viewType === VIEW_TYPE.LIST) {
      setFilters(filterPayload);
    } else {
      handleSaveRequirement(filterPayload);
    }
  };

  const handleResetAndClose = () => {
    resetRequirementInfo();
    setRequirementModalOpen(false);
  };

  const handleClickNewActivity = (contactId) => {
    setCurrentContactId(contactId);
    noteItemRef.current.onOpenDairyNoteItem(null);
  };

  const handleDiaryItemSubmitCompleteFunc = () => {
    toast.info("Diary saved successfully.");
    loadDiaryAjaxForContact();
  };

  const handleClickSendMessage = (contactId) => {
    let foundContact = null;
    for (const stage of stages) {
      const contact = stage.contacts.find((c) => c.contactID === contactId);
      if (contact) {
        foundContact = contact;
        break;
      }
    }

    if (foundContact) {
      const contactModel = {
        contactID: foundContact.contactID,
        firstName: foundContact.name?.split(" ")[0] || "",
        lastName: foundContact.name?.split(" ").slice(1).join(" ") || "",
        emailAddress: foundContact.emailAddress || "",
        contact: JSON.stringify({
          phone_dialing_code: foundContact.dialingCode || "",
          phone: foundContact.phoneNumber || "",
        }),
      };

      setSelectedContact(contactModel);
      setInitialMessage({
        type: "Email",
        date: new Date().toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          hour: "2-digit",
          minute: "2-digit",
        }),
        message: "",
      });
      setNewMessageDialogOpen(true);
    }
  };

  if (isLoading) {
    return <AjaxLoader />;
  }

  return (
    <>
      <div className="contact-main-component">
        <div className={"col-md-2"}>
          <ContactPipeline
            onClickMenu={handleOnClickMenu}
            onLeadClick={handleClickLead}
            pipelines={pipelines}
            selectedPipeline={selectedPipelineId}
            view={view}
          />
        </div>
        <div className={"col-md-10"}>
          <div className="contact-wrapper-section contact-section">
            <ContactFilter
              actions={actions}
              contactType={contactType}
              mLeadActionType={mLeadActionType}
              mLeadDateRange={mLeadDateRange}
              mLeads={mLeads}
              mLeadType={mLeadType}
              officeTags={officeTags}
              onChangeContactViewType={handleContactViewTypeChange}
              onChangeLeadActionType={handleChangeLeadActionType}
              onChangeLeadDateRange={handleLeadDateRangeChange}
              onChangeLeads={handleChangeLeads}
              onChangeLeadType={handleChangeLeadType}
              onChangeSeachText={handleChangeSeachText}
              onChangeTags={handleTagsChange}
              onChangeViewType={handleViewTypeChange}
              searchTerm={searchTerm}
              sourceTypesTag={sourceTypesTag}
              usersDD={usersDD}
              userTags={userTags}
              view={view}
              viewType={viewType}
              requirementInfo={requirementInfo}
              onOpenRequirementFilter={() => setRequirementModalOpen(true)}
            />

            {stages &&
              stages.length > 0 &&
              view !== VIEW.LEAD &&
              viewType !== VIEW_TYPE.LIST && (
                <div className="contact-draggable-area">
                  <ContactMilestone
                    actions={actions}
                    milestoneMaxHeight={milestoneMaxHeight}
                    officeTags={officeTags}
                    onClickNewActivity={handleClickNewActivity}
                    onClickSendEmail={handleClickSendEmail}
                    onClickSendMessage={handleClickSendMessage}
                    onDragEnd={handleDragEnd}
                    onUpdateMilestone={updateMilestone}
                    onWhatsappClick={handleWhatsappClick}
                    pipelines={cPipelines}
                    stages={stages}
                    tagColorFormatter={tagColorFormatter}
                    userTags={userTags}
                    viewType={viewType}
                  />
                  <OMSDiaryNoteItem
                    DiaryActionTags={diaryActionTags}
                    DNType={1}
                    htmlID="noteItem-contact"
                    ID={currentContactId}
                    IsReadOnly={actions.indexOf("create") < 0}
                    onDiaryItemSubmitCompleteFunc={
                      handleDiaryItemSubmitCompleteFunc
                    }
                    OnShowEnd={userSession?.headerValues?.onShowEnd}
                    OnShowStart={userSession?.headerValues?.onShowStart}
                    ref={noteItemRef}
                    UserID={userId}
                  />
                </div>
              )}

            {viewType !== VIEW_TYPE.LIST &&
              stages.length === 0 &&
              view !== VIEW.LEAD && (
                <div className="message-container">
                  <h4>
                    There are no milestones in the pipeline. Please configure
                    the pipeline with milestones to ensure it works correctly.
                  </h4>
                </div>
              )}

            {viewType === VIEW_TYPE.LIST &&
              selectedPipelineId !== "" &&
              view !== VIEW.LEAD && (
                <ContactGrid
                  contact={contactInfo}
                  contactViewType={contactInfo.selectedContactView}
                  pipelineID={selectedPipelineId}
                  searchTerm={searchTerm}
                  sources={contactInfo.selectedSources}
                  tags={contactInfo.selectedTags}
                  viewType={viewType}
                  filters={filters}
                />
              )}

            {view === VIEW.LEAD && (
              <ContactLeadGrid
                contact={contactInfo}
                mLeadActionType={mLeadActionType}
                mLeads={mLeads}
                mLeadType={mLeadType}
                pipelineID={selectedPipelineId}
                searchTerm={searchTerm}
                view={view}
                mLeadDateRange={mLeadDateRange}
              />
            )}
          </div>
        </div>
      </div>

      {selectedContact && (
        <NewMessageDialog
          open={newMessageDialogOpen}
          onOpenChange={setNewMessageDialogOpen}
          contact={selectedContact}
          initialMessage={initialMessage}
          variables={[
            {
              label: "Contact First Name",
              value: selectedContact.firstName || "",
              replace: "{{contact_first_name}}",
            },
            {
              label: "Contact Last Name",
              value: selectedContact.lastName || "",
              replace: "{{contact_last_name}}",
            },
            {
              label: "Contact Email",
              value: selectedContact.emailAddress || "",
              replace: "{{contact_email}}",
            },
            {
              label: "Contact Phone",
              value: selectedContact.contact
                ? JSON.parse(selectedContact.contact).phone_dialing_code +
                  JSON.parse(selectedContact.contact).phone
                : "",
              replace: "{{contact_phone}}",
            },
            {
              label: "Agent First Name",
              value: userSession?.firstName || "",
              replace: "{{agent_first_name}}",
            },
            {
              label: "Agent Last Name",
              value: userSession?.lastName || "",
              replace: "{{agent_last_name}}",
            },
            {
              label: "Agent Email",
              value: userSession?.emailAddress || "",
              replace: "{{agent_email}}",
            },
          ]}
          userId={userId}
        />
      )}

      <RequirementFilterModal
        isOpen={isRequirementModalOpen}
        onClose={() => setRequirementModalOpen(false)}
        onSave={handleSaveFilters}
        onReset={handleResetAndClose}
        initialFilters={requirementInfo}
      />
    </>
  );
};

export default ContactBoard;
